import { PRODUCT, PRODUCTV2 } from '../utils/APIUtil';
import axios from 'axios';
import AuthService from './auth/AuthService';

const Auth = new AuthService();
export default class ProductService {
  constructor() {
    this.fetch = this.fetch.bind(this);
  }

  async getProductList(jsonData) {
    const response = await axios.post(PRODUCTV2, jsonData, { headers: { Authorization: 'Bearer ' + Auth.getToken() } });
    const res = response.data;
    if (res.result === 'OK') {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(res.error);
    }

  }

  async getProductById(productId) {
    const res = await this.fetch(PRODUCT + '/byId/' + productId, {
      method: 'GET',
    });
    return Promise.resolve(res);
  }

  async getProductBySellerId(sellerId) {
    const res = await this.fetch(PRODUCT + '/' + sellerId, {
      method: 'GET',
    });
    return Promise.resolve(res);
  }

  async updateProduct(jsonData, id) {
    const response = await axios.put(PRODUCT + '/' + id, jsonData, { headers: { Authorization: 'Bearer ' + Auth.getToken() } });
    const res = response.data;
    if (res.success) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res.error);
    }
  }

  fetch(url, options) {
    // performs api calls sending the required authentication headers
    const headers = {
      'Accept': 'application/json',
    };
    headers['Authorization'] = 'Bearer ' + Auth.getToken();
    return fetch(url, {
      headers,
      ...options,
    })
      .then(this._checkStatus)
      .then(response => response.json());
  }

  _checkStatus(response) {
    // raises an error in case response status is not a success
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  }
}
